module.exports = __webpack_public_path__ + "static/media/8.0f59251a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/8.jpg
// module id = 71
// module chunks = 0